import { render } from "./TableBodyRow.vue?vue&type=template&id=1d3bac10&scoped=true"
import script from "./TableBodyRow.vue?vue&type=script&lang=ts"
export * from "./TableBodyRow.vue?vue&type=script&lang=ts"

import "./TableBodyRow.vue?vue&type=style&index=0&id=1d3bac10&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1d3bac10"

export default script